import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { selectors, actions } from 'shared/store'
import { LoadingStatus, UserRole } from 'shared/types'
import { useUserRole } from './useUserRole'

interface HookParams {
  refetch?: boolean
}

export const useUserSubscription = (params?: HookParams) => {
  const { userType, loading: userRoleLoading } = useUserRole()
  const dispatch = useDispatch()
  const { loading: userLoading } = useSelector(selectors.users.getUserActions)
  const { data: subscriptionData, loading: subscriptionLoading } = useSelector(
    selectors.users.getCurrentSubscriptionState
  )

  const isLoading = [
    subscriptionLoading,
    userLoading,
    userRoleLoading,
  ].includes(LoadingStatus.Pending)

  useEffect(() => {
    if (
      userType === UserRole.User &&
      userLoading === LoadingStatus.Succeeded &&
      userRoleLoading === LoadingStatus.Succeeded
    ) {
      dispatch(
        actions.users.getCurrentSubscription({
          disableRefetch: !params?.refetch,
        })
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userLoading, userRoleLoading, userType])

  return { subscriptionData, isLoading }
}
